module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Youtube-d5ce860f7033c15f4cfba350daf265bd.svg";